var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login content"},[_c('div',{staticClass:"app-content"},[_vm._v("403 - Forbidden")]),_c('div',{staticClass:"return-button"},[_c('b-button',{on:{"click":_vm.returnToLogin}},[_vm._v("Login")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }